frappe.ui.form.ControlDatetime = class ControlDatetime extends frappe.ui.form.ControlDate {
	set_formatted_input(value) {
		if (this.timepicker_only) return;
		if (!this.datepicker) return;
		if (!value) {
			this.datepicker.clear();
			// Reset the calendar view to "now" so a re-opened picker doesn't keep
			// showing the previously-selected month (upstream #40970).
			this.datepicker.date = this.get_now_date();
			return;
		} else if (value.toLowerCase() === "today") {
			value = this.get_now_date();
		} else if (value.toLowerCase() === "now") {
			value = frappe.datetime.now_datetime();
		}
		// @dokos: keep the datepicker's internal selection in sync with the field value
		// whenever the control (and its reused datepicker) is bound to a new document, so
		// a stale selection from a previously-opened doc doesn't persist (calendar slot ->
		// Back -> new slot). origin bd357fbf43; upstream's set_formatted_input has no such
		// sync. sync_datepicker_state() below also reconciles the timepicker (ft-pr-41069).
		const should_refresh = this.last_value && this.last_value !== value;
		value = this.format_for_input(value);
		this.$input && this.$input.val(value);
		if (should_refresh) {
			// @dokos: guard the programmatic selectDate so onSelect (ControlDate,
			// date.js) doesn't fire a spurious "change" event that dirties the form and
			// re-runs change handlers. set_formatted_input runs programmatically on
			// refresh (last_value is the *previous* value, set by set_input before us),
			// not on user input (origin bd357fbf43, re-restored on #40970). The
			// sync_datepicker_state branch below mutates the picker directly and so needs
			// no guard. See frappe/tests/test_dokos_specificities.py.
			this._suppress_change = true;
			this.datepicker.selectDate(frappe.datetime.user_to_obj(value));
			this._suppress_change = false;
		} else if (value) {
			this.sync_datepicker_state(frappe.datetime.user_to_obj(value));
		}
	}

	sync_datepicker_state(date) {
		const selected_date = this.datepicker.selectedDates[0];
		const last_selected_date = this.datepicker.lastSelectedDate;
		const timepicker = this.datepicker.timepicker;
		const date_value = date.getTime();
		const has_stale_time =
			timepicker &&
			(Number(timepicker.hours) !== date.getHours() ||
				Number(timepicker.minutes) !== date.getMinutes() ||
				Number(timepicker.seconds) !== date.getSeconds());
		const has_stale_state =
			!selected_date ||
			selected_date.getTime() !== date_value ||
			!last_selected_date ||
			last_selected_date.getTime() !== date_value ||
			has_stale_time;

		if (!has_stale_state) return;

		this.datepicker.selectedDates = [date];
		this.datepicker.lastSelectedDate = date;
		this.datepicker.date = date;

		if (timepicker) {
			timepicker._setTime(date);
			timepicker.update();
		}
	}

	get_start_date() {
		this.value = this.value == null || this.value == "" ? undefined : this.value;
		let value = frappe.datetime.convert_to_user_tz(this.value);
		return frappe.datetime.str_to_obj(value);
	}
	set_date_options() {
		super.set_date_options();
		this.today_text = __("Now");
		const sysdefaults = frappe.boot.sysdefaults;
		this.date_format = frappe.defaultDatetimeFormat;
		const time_format =
			sysdefaults && sysdefaults.time_format ? sysdefaults.time_format : "HH:mm:ss";
		$.extend(this.datepicker_options, {
			timepicker: true,
			timeFormat: time_format.toLowerCase().replace("mm", "ii"),
		});
	}

	get_now_date() {
		return frappe.datetime.now_datetime(true);
	}

	/** @param {string | null} value */
	parse(value) {
		let parsed = typeof value === "string" ? value.trim() : "";

		if (["today", "now"].includes(parsed.toLowerCase())) {
			parsed = frappe.datetime.now_datetime(false);
		} else if (parsed) {
			parsed = frappe.datetime.user_to_str(parsed, false);
			parsed = frappe.datetime.convert_to_system_tz(parsed, true);
		}

		if (parsed === "Invalid date") {
			console.warn("Invalid datetime", value); // eslint-disable-line
			parsed = "";
		}

		return parsed;
	}

	format_for_input(value) {
		if (!value) return "";

		return frappe.datetime.str_to_user(value, false);
	}

	set_description() {
		const description = this.df.description
			? __(this.df.description, null, this.df.parent)
			: this.df.description;
		const time_zone = this.get_user_time_zone();

		if (!this.df.hide_timezone) {
			// Always show the timezone when rendering the Datetime field since the datetime value will
			// always be in system_time_zone rather then local time.
			if (!description) {
				this.df.description = time_zone;
			} else if (!description.includes(time_zone)) {
				this.df.description = description + "<br>" + time_zone;
			}
		}
		super.set_description();
	}

	get_user_time_zone() {
		return frappe.boot.time_zone ? frappe.boot.time_zone.user : frappe.sys_defaults.time_zone;
	}

	set_datepicker() {
		super.set_datepicker();
		if (this.datepicker.opts.timeFormat.indexOf("s") == -1) {
			// No seconds in time format
			const $tp = this.datepicker.timepicker;
			$tp.$seconds.parent().css("display", "none");
			$tp.$secondsText.css("display", "none");
			$tp.$secondsText.prev().css("display", "none");
		}
	}

	get_model_value() {
		let value = super.get_model_value();
		if (!value && !this.doc) {
			value = this.last_value;
		}

		return !value ? "" : frappe.datetime.get_datetime_as_string(value);
	}
};
